<template>
	<v-dialog v-model="dialog" persistent max-width="700px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap>
						<v-flex md6>
							<v-textarea v-model="form.text" :error-messages="textErrors" auto-grow box rows="1" label="Kpi" required @input="$v.form.text.$touch()" @blur="$v.form.text.$touch()"></v-textarea>

							<v-menu ref="dueDateMenu" v-model="form.dueDateUTC.menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="form.dueDateUTC.date" lazy transition="scale-transition" offset-y full-width min-width="290px">
								<v-text-field slot="activator" v-model="dueDateFormatted" label="Due Date" readonly></v-text-field>
								<v-date-picker v-model="form.dueDateUTC.date" @input="$refs.dueDateMenu.save(form.dueDateUTC.date)"></v-date-picker>
							</v-menu>

							<v-switch v-model="form.complete" label="KPI Complete"></v-switch>
						</v-flex>
						<v-flex md1></v-flex>
						<v-flex md5>
							<v-card class="ma-0">
								<v-toolbar flat dense cad dark color="pink">
									<v-toolbar-title class="subheading"> <v-icon>mdi-bell-ring-outline</v-icon> Reminders </v-toolbar-title>
									<v-spacer></v-spacer>
								</v-toolbar>

								<v-divider></v-divider>
								<v-card-text class="pa-0">
									<reminder-list :reminders="form.reminders" @onEditReminder="onEditReminder" @onAddReminder="onAddReminder" @onDeleteReminder="deleteReminder" />
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn flat @click="onCancelClick">Cancel</v-btn>
					<!-- <v-btn @click="deleteKpi" v-if="this.form.id != undefined" color="error" flat>Remove KPI</v-btn> -->
					<v-btn color="primary" flat @click="submit">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>

		<reminder-editor
			v-if="reminderEditorDialog"
			:reminder="editedReminder"
			:existing-reminders="form.reminders"
			:title="reminderEditorTitle"
			:dialog="reminderEditorDialog"
			:default-minutes="10080"
			@closeEditor="reminderEditorDialog = false"
			@save="saveReminder"
			@delete="deleteReminder"
		/>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import ReminderList from '@/components/reminders/ReminderList';
	import ReminderEditor from '@/components/reminders/ReminderEditor';

	export default {
		props: {
			kpi: {
				type: Object,
				default: () => ({
					id: null,
					text: null,
					dueDateUTC: null,
					comments: [],
					complete: false,
					reminders: []
				})
			},
			dialog: {},
			title: {
				required: true,
				type: String
			},
			canEdit: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		components: {
			ReminderList,
			ReminderEditor
		},
		created() {
			const kpi = JSON.parse(JSON.stringify(this.kpi));

			this.form = {
				id: kpi.id,
				text: kpi.text,
				dueDateUTC: {
					date: this.$options.filters.formatDate(kpi.dueDateUTC, 'YYYY-MM-DD'),
					menu: false
				},
				complete: kpi.complete,
				reminders: kpi.reminders
			};

			if (kpi.id === null) {
				this.form.reminders = this.getDefaultKpiReminders();
			}

			this.originalFormJson = JSON.stringify(this.form);
		},
		data() {
			return {
				form: {
					id: null,
					text: null,
					dueDateUTC: null,
					comments: [],
					complete: false,
					reminders: []
				},
				reminderEditorDialog: false,
				editedReminderIndex: -1,
				editedReminder: undefined,
				originalFormJson: null
			};
		},
		computed: {
			textErrors() {
				const errors = [];
				if (!this.$v.form.text.$dirty) return errors;
				!this.$v.form.text.required && errors.push('KPI is required.');
				return errors;
			},
			dueDateFormatted() {
				return this.$options.filters.formatDate(this.form.dueDateUTC.date);
			},
			reminderEditorTitle() {
				return this.editedReminderIndex === -1 ? 'New Reminder' : 'Edit Reminder';
			},
			isDirty() {
				return this.originalFormJson !== JSON.stringify(this.form);
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				text: { required }
			}
		},
		methods: {
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : this.newGuid(),
						text: this.form.text,
						dueDateUTC: this.form.dueDateUTC.date,
						complete: this.form.complete,
						reminders: this.form.reminders
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
			},
			deleteKpi() {
				if (confirm('Are you sure you want to delete this KPI?')) {
					this.$emit('delete', this.form.id);
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				(this.form.id = null), (this.form.text = null), (this.form.dueDateUTC.date = '');
			},
			onEditReminder(item) {
				this.editedReminderIndex = this.form.reminders.indexOf(item);
				this.editedReminder = Object.assign({}, item);
				this.reminderEditorDialog = true;
			},
			onAddReminder() {
				this.editedReminderIndex = -1;
				this.editedReminder = undefined;
				this.reminderEditorDialog = true;
			},
			saveReminder(reminder) {
				if (this.editedReminderIndex > -1) {
					Object.assign(this.form.reminders[this.editedReminderIndex], reminder);
				} else {
					this.form.reminders.push(reminder);
				}
			},
			deleteReminder(id) {
				this.reminderEditorDialog = false;
				const index = this.form.reminders.indexOf(this.form.reminders.find(x => x.id == id));
				if (index > -1) {
					this.form.reminders.splice(index, 1);
				}
			},
			getDefaultKpiReminders() {
				return [
					{
						id: this.newGuid(),
						deliveryMethods: [0],
						minutesBefore: 10080
					}
				];
			},
			onCancelClick() {
				if (this.isDirty) {
					if (confirm('You have unsaved changes, do you wish to proceed and lose these unsaved changes?')) {
						this.closeEditor();
					}
				} else {
					this.closeEditor();
				}
			}
		}
	};
</script>

<style scoped></style>
